export default __webpack_public_path__ + "static/media/500.e9a10361.png";